import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import store from './app/store';
import {Provider} from 'react-redux';
//import 'bootstrap/dist/css/bootstrap.css';
//import Router from './Components/Router';
import App from './App';


ReactDOM.render(
    <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
    document.getElementById('root')
);